import { useMemo } from 'react';
import { PlaceReportSmall } from '../common/types';
import { Button, SpaceBetween } from '@cloudscape-design/components';
import { formatDateString } from '../common/formatting/dateFormat';
import { PlacePeriodList } from './PlacePeriodList';
const scorecardUrl = '';

export type LatestReportInfoProps = {
  reports: PlaceReportSmall[];
  placeName?: string;
};

export function LatestReportInfo(props: LatestReportInfoProps) {
  const { reports, placeName } = props;

  const latestReport = useMemo(() => {
    if (reports.length === 0) {
      return null;
    }
    return (
      reports.sort(
        (a, b) => new Date(b.report_at).getTime() - new Date(a.report_at).getTime(),
      )[0] ?? null
    );
  }, [reports]);

  if (!latestReport) {
    return '-';
  }

  return (
    <SpaceBetween direction="vertical" size="xs">
      <Button
        href={`${scorecardUrl}/${latestReport.slug ?? latestReport.uuid}`}
        variant="normal"
        target="_blank"
        iconName="transcript"
        wrapText={false}
        iconAlign="left"
      >
        {formatDateString(latestReport.report_at)}
      </Button>
      <PlacePeriodList
        report={latestReport}
        name={placeName ?? 'Report'}
      />
    </SpaceBetween>
  );
}
